import { createPinia, setActivePinia, type Pinia } from 'pinia'

interface PiniaWithStores extends Pinia {
  _s: Map<string, any>
}

const pinia = createPinia()

setActivePinia(pinia)
window.__HOST_CONTEXT__ = window.__HOST_CONTEXT__ || {}
window.__HOST_CONTEXT__.piniaStores = (pinia as PiniaWithStores)._s
export default pinia
